import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import logger from '../../utils/logger';

const ConfirmDialog = ({ open, onClose, onConfirm, title, message, item, confirmText = 'Confirm', confirmColor = 'primary' }) => {
  const handleConfirm = () => {
    try {
      if (item) {
        onConfirm(item);
      } else {
        onConfirm();
      }
      onClose();
    } catch (error) {
      logger.error('Error in ConfirmDialog:', error);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || 'Confirm Action'}</DialogTitle>
      <DialogContent>
        <Typography>
          {message || 'Are you sure you want to perform this action?'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color={confirmColor} variant="contained">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
